import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { PurchasesQuoteRequestService } from '../../../../core/services/purchases/purchases-quote-request/purchases-quote-request.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { CnpjPipe } from '../../../../shared/pipes/cpnj.pipes'
import { TelefonePipe } from '../../../../shared/pipes/phone.pipes'
import { JsonPipe } from '@angular/common'
import { PurchasesQuoteRequestItinerariesService } from '../../../../core/services/purchases/purchases-quote-request-itineraries/purchases-quote-request-itineraries.service'
import { MatProgressBar } from '@angular/material/progress-bar'

@Component({
  selector: 'modal-purchases-supplier-itineraries',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    CnpjPipe,
    TelefonePipe,
    JsonPipe,
    MatProgressBar,
  ],
  templateUrl: './modal-purchases-supplier-itineraries.component.html',
  styleUrl: './modal-purchases-supplier-itineraries.component.scss',
  providers: [PurchasesQuoteRequestService],
  standalone: true,
})
export class ModalPurchasesSupplierItinerariesComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private purchasesQuoteRequestItinerariesService: PurchasesQuoteRequestItinerariesService,
    private dialogRef: MatDialogRef<ModalPurchasesSupplierItinerariesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data.item) {
      this.item = data.item
    }
  }

  item: any = {}
  loading: boolean = false
  listItineraries: any[] = []

  ngOnInit(): void {
    this.getItineraries()
  }

  close() {
    this.dialogRef.close()
  }

  getItineraries() {
    this.loading = true
    this.listItineraries = []
    this.purchasesQuoteRequestItinerariesService
      .getPurchasesQuoteRequestItinerariesByRequestId(this.item.id)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          // this.listItineraries = response.data
          if (response.data.origem.id) {
            this.listItineraries.push(response.data.origem)
          }
          if (response.data.paradas) {
            for (let i = 0; i < response.data.paradas.length; i++) {
              let ele = response.data.paradas[i]
              this.listItineraries.push(ele)
            }
          }
          if (response.data.destino.id) {
            this.listItineraries.push(response.data.destino)
          }
        },
        error: (err: ErrorRequestModel) => {
          console.error(err)
        },
        complete: () => {
          this.loading = false
        },
      })
  }
}
